import i18next from 'i18next';

export const MAX_SPEAKER_NAME_LENGTH = 100;
export const MAX_SPEAKER_POSITION_LENGTH = 100;

export function validateSpeakerName(value: string): string | undefined {
  const trimmed = value.trim();

  if (!trimmed) {
    return i18next.t('translations:manager.webcastSetup.speakers.name.validation.required');
  }

  if (trimmed.length > MAX_SPEAKER_NAME_LENGTH) {
    return i18next.t('translations:manager.webcastSetup.speakers.name.validation.tooLong', {
      maxLength: MAX_SPEAKER_NAME_LENGTH,
    });
  }

  return undefined;
}

export function validateSpeakerPosition(value: string): string | undefined {
  const trimmed = value.trim();

  // Position is optional now — only validate length when something was entered.
  if (trimmed.length > MAX_SPEAKER_POSITION_LENGTH) {
    return i18next.t('translations:manager.webcastSetup.speakers.position.validation.tooLong', {
      maxLength: MAX_SPEAKER_POSITION_LENGTH,
    });
  }

  return undefined;
}
